module.exports = __webpack_public_path__ + "img/Processed edible goods.e836b89b.png";